<safe-html-renderer *ngIf="withReference" [unsafeHtmlContent]="referenceName"
  innerClass="text-center info-text-s description-frame text-color-primary theme-border-bottom-negative"
  innerNgClass="!noButtons?'padding-top-s':''"></safe-html-renderer>

<!-- (innerClick)="goToReference()" -->

<ion-button *ngIf="withReference && withReferenceLink"
  class="as-text element-selector info-text-s text-color-primary text-center" (click)="goToReference()">
  <icon-wrapper class="slot-icon-padding" slot="start" [icon]="appIcons.www" [custom]="true"></icon-wrapper>
  <span class="button-font-size-s">{{referenceLabel}}</span>
</ion-button>